import React from 'react';
import Bar from '../JSX/Bar';
import Footer from '../JSX/Footer';
import cv from './cv.svg';


const CV = () => {
  return (
        <div>
        <Bar/>
  {/* ======= Portfolio Section ======= */}
  <section id="portfomnd" className="portfolio" data-aos="fade-up">
    <div className="container">
      <div className="section-header">
        <h2>About Us</h2>
        <img src={cv} alt="cv" height="100%" width="100%"  />
      </div>
    </div>
  </section>
  {/* End Portfolio Section */}
        <Footer/>
        </div>
  );
};

export default CV;